import {useQuery} from "@tanstack/react-query";
import {getItem} from "../../../app/getters/getItem.js";


export const usePozycjaSlownika = (slownik, id, enabled = true) => {
    return useQuery({
        queryKey: [`pozycja_slownika__${slownik}`, id],
        queryFn: () => getItem(`/slowniki/${slownik}/${id}`),
        enabled: enabled,
    })
}